<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <h4 class="card-title">Expired Link</h4>
      <div class="margin-top-30">
        <div>
          <p>The link that you have provided has expired or invalid.</p>
        </div>
        <div class="mt-4">
          <a class="btn btn-primary" [routerLink]="['/auth/login']">Go back to login page</a>
        </div>
      </div>
    </div>
  </div>
</div>
